import { render, staticRenderFns } from "./SalesDeliveryViewValidateDeliveryForm.vue?vue&type=template&id=480d7728&scoped=true"
import script from "./SalesDeliveryViewValidateDeliveryForm.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryViewValidateDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./SalesDeliveryViewValidateDeliveryForm.vue?vue&type=style&index=0&id=480d7728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d7728",
  null
  
)

export default component.exports